import { useEffect, useState } from 'react';
import { api } from './api';

/**
 * Auth-mode awareness for both login screens: in hub mode the app never
 * collects credentials — sign-in happens on Plaidware Hub and the shared
 * .plaidware.com session cookie carries over. useAuthMode drives which
 * screen renders; HubSignIn is the hand-off panel.
 */

export interface AuthMode {
  mode: 'stub' | 'hub';
  hubBaseUrl: string | null;
}

export function useAuthMode(): AuthMode | null {
  const [mode, setMode] = useState<AuthMode | null>(null);
  useEffect(() => {
    api
      .get<AuthMode>('/api/auth/mode')
      .then(setMode)
      .catch(() => setMode({ mode: 'stub', hubBaseUrl: null })); // old servers have no /mode
  }, []);
  return mode;
}

export function HubSignIn({ hubBaseUrl, onSignedIn, title }: { hubBaseUrl: string; onSignedIn: () => void; title: string }) {
  const [notYet, setNotYet] = useState(false);
  const checkSession = async () => {
    try {
      await api.get('/api/auth/me');
      onSignedIn();
    } catch {
      setNotYet(true);
    }
  };
  return (
    <div className="auth-card">
      <h1>{title}</h1>
      <p className="muted">Sign-in happens on Plaidware Hub — your Hub session carries over here automatically.</p>
      <div className="row">
        {/* Hub bounces back here after sign-in (`redirect` param, *.plaidware.com only) */}
        <a
          className="btn primary"
          href={`${hubBaseUrl}/login?redirect=${encodeURIComponent(window.location.origin + window.location.pathname)}`}
        >
          Sign in on Plaidware Hub
        </a>
        <button type="button" onClick={() => void checkSession()}>
          I've signed in — continue
        </button>
      </div>
      {notYet && (
        <p className="callout callout--danger" role="alert" style={{ marginTop: 12 }}>
          No session found yet. Finish signing in on the Hub tab (make sure it's{' '}
          <span className="mono">{hubBaseUrl.replace('https://', '')}</span>, not the production Hub), then try
          again.
        </p>
      )}
    </div>
  );
}
